import { DigitalVisitReasonEnum } from "@/lib/__generated/api";
import { REASON_FOR_VISIT_MAPPING } from "@/lib/constants";
import type { SchedulerContext } from "@/types/scheduler-machine";

export const getDataLayerBrand = (reason: DigitalVisitReasonEnum | null) =>
  reason === DigitalVisitReasonEnum.ClearAligners ? "mottoaligners" : "aspendental";

// Language, brand, reason and facility fields carried by every scheduler step event.
export const getBaseDataLayerParams = (context: SchedulerContext) => ({
  language_preference: context.currentLanguage,
  brand: getDataLayerBrand(context.reasonForVisit),
  reason_for_visit: context.reasonForVisit,
  reason_for_visit_id: context.reasonForVisit && REASON_FOR_VISIT_MAPPING[context.reasonForVisit],
  ...(context.facility?.code && {
    website_selected_facility_id: context.facility.code,
  }),
  ...(context.facility?.name && {
    website_selected_facility_name: context.facility.name,
  }),
});

// Booking fields shared by the review and confirmation step events.
export const getAppointmentDataLayerParams = (context: SchedulerContext) => ({
  appointment_facility_id: context.facility?.code,
  appointment_facility_name: context.facility?.name,
  lead_score: context.appointmentData.leadScore,
  dental_insurance: context.patientData.dentalInsurance,
  lead_tier_national: context.appointmentData.leadTierNational,
  lead_tier_office: context.appointmentData.leadTierOffice,
});
